import React from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
} from "@material-ui/core";
import { LOCALE } from "../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../common/actions/CommonActions";
import { VacancyRepository } from "../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../vacancyApplication/VacancyAppRepository";
import Card from "../../common/components/Card/Card";
import CardHeader from "../../common/components/Card/CardHeader";
import CardBody from "../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";

export default function DashboardComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.dashboard));
  }, [dispatch]);

  return (
    <div>
      <Grid container>
        <Grid item xs={2}></Grid>
        <Grid item xs={8}>
          <Typography variant="h4" align="center">
            <strong>
              {" "}
              Добредојдовте на <br></br>
              националниот систем за<br></br> Кариерно напредување на наставници
              и стручни соработници
            </strong>
            <br></br>
          </Typography>
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={2}></Grid>
        <Grid item xs={8} style={{ textAlign: "center" }}>
          <img
            alt=""
            src={require("../../assets/img/grb_gold.png")}
            width="240px"
            style={{ opacity: "70%" }}
          ></img>
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={2}></Grid>
        <Grid item xs={8} style={{ textAlign: "center" }}>
          <Typography variant="caption">
            Министерство за образование и наука
          </Typography>
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    </div>
  );
}
